import React from 'react';
import { connect } from 'react-redux';
import {isDesktop} from "../../utils";
import {
    getIsLoadingRecoveryPassword,
    getMobile,
    getMobileErrorCode,
    getRecoveryPasswordMessage,
    getRecoveryPasswordStatus,
    isModalOpen
} from "../../selectors";
import {sendRecoveryPasswordAction, setModalOpenAction,} from "../../reducers";
import {SERVER_CDN_PATH} from "../../constants";

const stateToProps = state => ({
    isModalOpen: isModalOpen(state),
    recoveryPasswordStatus: getRecoveryPasswordStatus(state),
    isLoadingRecoveryPassword: getIsLoadingRecoveryPassword(state),
    mobile: getMobile(state),
    recoveryPasswordMessage: getRecoveryPasswordMessage(state),
});

const actionsToProps = dispatch => ({
    sendRecoveryPassword: payload => dispatch(sendRecoveryPasswordAction(payload)),
    setModalOpen: payload => dispatch(setModalOpenAction(payload)),
});

const ModalResetPassword = props => {

    if (props.isModalOpen) {
        let modalBody = '';

        if (props.recoveryPasswordStatus === 1) {
            modalBody = (
                <div className="modal-body">
                    <div className="modal-note">
                        <div className="modal-img">
                            <div className="modal-icon correct-icon"></div>
                        </div>
                        <div className="modal-message">Verification Link Sent</div>
                    </div>
                    <div className="modal-txt">The verification link has been sent to the entered phone number.
                    </div>
                    <div className="modal-txt">The user can recover the account by completing the steps in the
                        SMS.
                    </div>
                    <div className="modal-button" onClick={() => redirectToHome()}>Return to Homepage</div>
                </div>
            );
        } else if (props.recoveryPasswordStatus === 0) {
            const showButton = !props.isLoadingRecoveryPassword?
                <div className="modal-button" onClick={() => sendVerificationLink()}>
                    Send Verification Link
                </div>
                :
                <span style={{marginTop: '20px'}}><img src={`/${SERVER_CDN_PATH}/img/loading.gif`} alt="spinner"/></span>
            ;

            modalBody = (
                <div className="modal-body">
                    <div className="modal-note">
                        <div className="modal-img">
                            <div className="modal-icon error-icon"></div>
                        </div>
                        <div className="modal-message">Mobile number already exists</div>
                    </div>
                    <div className="modal-txt">The mobile number is already assigned to an existing
                        account.
                    </div>
                    <div className="modal-txt">To help recover and verify the account, send a
                        verification
                        link to the entered phone number by clicking below.
                    </div>
                    {showButton}
                </div>
            );
        } else {
            modalBody = (
                <div className="modal-body">
                    <div className="modal-note">
                        <div className="modal-img">
                            <div className="modal-icon error-icon"></div>
                        </div>
                        <div className="modal-message">Error sending verification link</div>
                    </div>
                    <div className="modal-txt">
                        {props.recoveryPasswordMessage}
                    </div>
                    <p className="callout error p10 txt-l">{props.recoveryPasswordMessage}</p>
                </div>
            );
        }

        const updateModal = open => {
            props.setModalOpen(open);
        }

        const sendVerificationLink = () => {
            if (props.mobile !== '') {
                props.sendRecoveryPassword({
                    mobile: props.mobile,
                    source: isDesktop() === true ? 'Desktop' : 'Mobile',
                });
            }
        }

        const redirectToHome = () => {
            window.location.href = server.links.home_shop;
        }

        return (
            <div className="modals verification-link-modal">
                <div className="verification-link-modal">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-head">
                                <a className="modal-close" href="#" onClick={() => updateModal(false)}></a>
                            </div>
                            {modalBody}
                        </div>
                    </div>
                </div>
                <div className="modal-mask"></div>
            </div>
        );
    }
}

export default connect(
    stateToProps,
    actionsToProps
)(ModalResetPassword);
